import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { Stack } from "@/components/ui";
import { type PredictionStatus } from "@/schemas";
import { cn } from "@/utils/cn";

import PredictionChart from "./chart/prediction-chart";
import PredictionActionBar from "./prediction-action-bar";
import PredictionContracts from "./prediction-contracts";
import PredictionHeader from "./prediction-header";

interface PredictionCardProps {
  status: PredictionStatus;
  isFeatured?: boolean;
  isQuoted?: boolean;
}

const PredictionCard = ({
  status,
  isFeatured = false,
  isQuoted = false,
}: PredictionCardProps) => {
  const isSportsLayout =
    status.prediction.category === "Sports" &&
    status.prediction.contracts.length === 2;

  const calculateSpace = () => {
    if (isFeatured) return 4;
    if (isSportsLayout) return 3;
    return 4;
  };

  return (
    <Link
      key={status.id}
      to={`/predictions/${status.id}`}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={cn({
          "h-72 w-full border p-4 sm:rounded-xl": !isQuoted,
          "md:col-span-2": isFeatured,
          "size-full": isQuoted,
        })}
      >
        <Stack space={calculateSpace()} className="flex h-full flex-1 flex-col">
          <PredictionHeader status={status} isFocused={isFeatured} />
          <div
            className={cn({
              "grid grid-cols-1 gap-9 md:grid-cols-2": isFeatured,
              "h-full": !isFeatured,
            })}
          >
            <Stack
              space={4}
              justifyContent="between"
              className={cn({ "h-full": !isFeatured })}
            >
              <PredictionContracts
                status={status}
                layout={isFeatured ? "featured" : "timeline"}
              />
              {!isQuoted && <PredictionActionBar status={status} />}
            </Stack>

            {isFeatured && (
              <div className="hidden h-full flex-1 md:block">
                <PredictionChart status={status} size="big" />
              </div>
            )}
          </div>
        </Stack>
      </div>
    </Link>
  );
};

export default PredictionCard;
